import { createSlice } from '@reduxjs/toolkit';

export const selectedBinSlice = createSlice({
    name: "selectedBin",
    initialState: 0,
    reducers: {
        set: (state, action) => {
            state = Number(action.payload);
            return state;
        }
    }
})

export const selectedBinActions = selectedBinSlice.actions;

export default selectedBinSlice.reducer;